import React, {useState} from "react";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton,
} from '@mui/x-data-grid';
import {Typography} from '@material-ui/core';
import {useSelector} from "react-redux";
import {map_events} from "./utils/mapping";
import {formattingMoney} from "./utils/formatting";
import {getCurrencySymbol} from "./utils/currency";

export default function () {
    const data = useSelector(store => store.portfolio?.data);
    const rows = map_events(data.events.coupons, data.s.securities);
    const [sortModel, setSortModel] = useState([
        {
            field: 'd',
            sort: 'desc',
        },
    ]);
    const columns = [
        {
            field: 'ticker',
            headerName: 'Актив',
            description: 'Актив',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{params.value}</Typography>
                    <Typography color="textSecondary" variant="body2">{params.api.getCellValue(params.id, 'name')}</Typography>
                </div>
            )
        },
        {
            field: 'd',
            type: 'date',
            align: 'right',
            headerName: 'Дата',
            description: 'Дата',
            valueFormatter: (params) => {
                return `${(new Date(params.value)).toLocaleDateString('ru-RU',{year: 'numeric', month: 'short', day: 'numeric'})}`;
            },
            width: 125,
        },
        {
            field: 'v_pc',
            headerName: 'Размер',
            description: 'Размер',
            type: 'number',
            align: 'right',
            minWidth: 70,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 'v')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 's_pc',
            headerName: 'Сумма',
            description: 'Сумма',
            type: 'number',
            align: 'right',
            minWidth: 70,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 's')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 'cnt',
            headerName: 'Кол-во',
            description: 'Количество облигаций, по которым были выплачены купоны',
            type: 'number',
            align: 'right',
            minWidth: 90,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))}`;
            },
        },
    ];

    return (
                <DataGrid
                    autoHeight
                    pageSize={25}
                    columns={columns}
                    rows={rows}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                    disableColumnMenu
                    components={{
                        Toolbar: function CustomToolbar() {
                            return (
                                <GridToolbarContainer>
                                    <GridToolbarColumnsButton />
                                    <GridToolbarFilterButton />
                                </GridToolbarContainer>
                            );
                        },
                    }}
                />
    );
}
